/*说明
  1. main.js里这样调用
    import common from './lib/common'
    Vue.use(common);

  2. 组件里直接这样调用this.test();
*/
import { Message } from "element-ui";

Date.prototype.format = function(_, date) {
  console.log(date);
  if (!date) return "";
  let o = {
    "Y+": date.getFullYear(), //月份
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(_))
    _ = _.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (let k in o)
    if (new RegExp("(" + k + ")").test(_))
      _ = _.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return _;
};

export default {
  install(Vue, options) {
    Vue.prototype.format = function(_, date) {
      console.log(date);
      if (!date) return "";
      let o = {
        "Y+": date.getFullYear(), //月份
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(_))
        _ = _.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(_))
          _ = _.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return _;
    };
    Vue.prototype.hiddenPhone = function(val) {
      var isMobile = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (val.length >= 11) {
        for (let i = 0; i < val.length; i++) {
          if (i + 10 > val.length) {
            return val;
          } else {
            if (isMobile.test(val.substring(i, i + 11))) {
              val =
                val.substring(0, i) +
                val.substring(i, i + 3) +
                "***" +
                val.substring(i + 7, i + 11) +
                val.substring(i + 11, val.length);
            }
          }
        }
      } else {
        return val;
      }
    };
    //可以自定义变量
    Vue.prototype.formatDate = function(_, date) {
      let o = {
        "Y+": date.getFullYear(), //月份
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(_))
        _ = _.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(_))
          _ = _.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return _;
    };

    // 日期，在原有日期基础上，增加days天数，默认增加1天
    Vue.prototype.addDate = function(date, days) {
      if (days == undefined || days == "") {
        days = 1;
      }
      var date = new Date(date);
      date.setDate(date.getDate() + days);
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return (
        date.getFullYear() +
        "-" +
        this.getFormatDate(month) +
        "-" +
        this.getFormatDate(day)
      );
    };
    Vue.prototype.getFormatDate = function(arg) {
      if (arg == undefined || arg == "") {
        return "";
      }
      var re = arg + "";
      if (re.length < 2) {
        re = "0" + re;
      }
      return re;
    };
    Vue.prototype.timeDiff = function(_date) {
      let currTime = new Date(); //开始时间
      let _timeDiff =
        currTime.getTime() - new Date(_date.replace(/-/g, "/")).getTime(); //时间差的毫秒数

      //计算出相差天数
      let days = Math.floor(_timeDiff / (24 * 3600 * 1000));

      //计算出小时数
      let leave1 = _timeDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      let _time = "";
      if (days === 0) {
        _time = hours + "小时 " + minutes + "分钟 ";
        if (hours === 0) {
          _time = minutes + "分钟 ";
        }
      } else if (days === -1) {
        _time = Math.abs(seconds - 0) + " 秒";
      } else {
        _time = days + "天 ";
      }

      return _time;
    };
    Vue.prototype.stringToNull = function(data) {
      let _date = data;
      if (_date == "" || _date == undefined) {
        return null;
      }
      return _date;
    };

    Vue.prototype.re = {
      //---------------正则-------------
      isMobile: /^[1][3,4,5,7,8,9][0-9]{9}$/,
      tmPassWord: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/,
      bankcard: /^([1-9]{1})(\d{14}|\d{18})$/
    };

    Vue.prototype.$handleCurrentChange = function(pageSize, pageNumber, list) {
      let currentCount = pageSize * pageNumber;
      let total = list.length;
      let startIndex = pageSize * (pageNumber - 1);
      if (currentCount <= total) {
        return list.slice(startIndex, startIndex + pageSize);
      } else {
        return list.slice(startIndex);
      }
    };
  }
};



// WEBPACK FOOTER //
// ./static/js/utils.js